var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.url
    ? _c(
        "div",
        { staticClass: "file-viewer" },
        [
          _c(
            "md-dialog",
            {
              attrs: { "md-active": _vm.isOpened },
              on: {
                "update:mdActive": function($event) {
                  _vm.isOpened = $event
                },
                "update:md-active": function($event) {
                  _vm.isOpened = $event
                },
                "md-closed": _vm.close
              }
            },
            [
              _c("embed", {
                staticClass: "file-viewer__embed",
                attrs: { src: _vm.url, title: "" }
              })
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e1702b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e1702b5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/modals/FileViewer.vue
// module id = P8ub
// module chunks = 1